<template>
  <div class="x-search-list">
    <x-search-option
      ref="searchOption"
      v-bind="$attrs"
      :dynamicTags="dynamicTags"
      :search-option-type="searchOptionType"
      v-model="state"
      :disabled="disabled"
      :trigger-on-focus="false"
      :placeholder="getPlaceholder()"
      @blur="handleBlur"
      @focus="handleFocus"
      @select="handleSelect"
      @remove-tag="removeTag"
      @input="handleInput"
      :row-key="rowKey"
      :row-name="rowName"
      :debounce="getDebounce"
      :trigger-search="handleTriggerSearch">
      <template v-slot:search-option="{ item }">
        <slot name="search-option" :item="item"></slot>
      </template>
    </x-search-option>
    <x-list-page-dialog
      ref="dialog"
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="dialogVisible"
      :buttonConfig="buttonConfig"
      :condition-config="conditionConfig"
      :columns="realColumns"
      @cell-dblclick="handleCellDbclick"
      @opened="handleOpened"
    ></x-list-page-dialog>
  </div>
</template>

<script>
import searchDialogMixin, {SINGLE_SELECT} from '@/mixin/search-dialog-mixin';
import {Notification} from 'element-ui';
export default {
  name: 'XSearchList',
  inheritAttrs: false,
  mixins: [searchDialogMixin],
  props: {
    conditionConfig: Object,
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    quickQueryData: Function
  },
  data() {
    return {
      buttonConfig: {
        list: []
      }
    };
  },
  created() {
    const list = [
      {
        name: '查询',
        click: this.search
      },
      {
        name: '返回数据',
        click: this.returnData
      }
    ];
    if (this.showReturnAllData && this.searchOptionType !== SINGLE_SELECT) {
      list.push({
        name: '返回所有数据',
        click: this.returnAllData
      });
    }
    this.buttonConfig.list = list;
  },
  methods: {
    handleOpened() {
      if (this.state) {
        const model = this.conditionConfig.model;
        model[this.rowKey] = this.state;
      }
      this.$refs.dialog.reLoadData();
    },
    handleCellDbclick({row}) {
      this.dialogSelectCallback([row]);
    },
    async showDialog(flag) {
      if (this.validate && await this.validate({xSearchList: this}) === false) {
        return;
      }
      if (flag) {
        this.$refs.dialog.quickQuery({[this.rowKey]: this.state}).then((data) => {
          if (this.quickQueryData) {
            data = this.quickQueryData({data, vm: this});
          } else {
            // data的结构有可能是一个数组或者{list}
            if (!Array.isArray(data)) {
              data = data.list;
            }
          }
          if (data.length === 1) {
            this.dialogSelectCallback(data);
          } else {
            this.dialogVisible = true;
          }
        }).catch((error) => {
          Notification.error(error.message);
          this.dialogVisible = true;
          throw error;
        });
      } else {
        this.dialogVisible = true;
      }
    }
  },
  computed: {
    realColumns() {
      const arr = [];
      arr.push({
        field: 'listPageDialogSelect',
        type: this.searchOptionType === SINGLE_SELECT ? 'radio' : 'checkbox',
        width: 50,
        headerAlign: 'center',
        align: 'center',
        orderValue: -100
      });
      arr.push({
        field: 'listPageDialogSeq',
        type: 'seq',
        title: '序号',
        width: 50,
        headerAlign: 'center',
        align: 'center',
        orderValue: -50
      });
      arr.push(...this.columns);
      return arr;
    }
  }
};
</script>
<style lang="scss">
@import "../../style/mixins/index";
</style>
